import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
  // Enable sending cookies with requests (httpOnly cookies)
  withCredentials: true,
});

// Request interceptor to add auth token (for backward compatibility)
api.interceptors.request.use(
  (config) => {
    // Still send Bearer token for backward compatibility during migration
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling and token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // If 401 and not already retried, try to refresh token
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        // Attempt to refresh token using httpOnly cookie
        await axios.post(`${BACKEND_URL}/api/auth/refresh`, {}, { 
          withCredentials: true 
        });
        // Retry the original request
        return api(originalRequest);
      } catch (refreshError) {
        // Refresh failed, clear local storage and redirect to login
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;
